import * as React from "react"

import Layout from "../components/Layout"

const ProjectFloorPlans = () => {
  return (
    <Layout>
      <h1>Sky Eden @Bedok Floor Plan</h1>

      <iframe
        title="Project_Floor_Plan"
        width="100%"
        height="600px"
        src="/FINAL_Brochure_Plan_R14.pdf#toolbar=0"
      ></iframe>
    </Layout>
  )
}

export default ProjectFloorPlans
